import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { SelectBudgetType } from "../admin/configuracion/select/SelectBudgetType";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import usePaginator from "../theme/Component/usePaginator";
import { ListMenu } from "../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { DropDown } from "../theme/Component/DropDown";
import AutoChart from "../../core/graph/AutoChart";
import { ViewBudgetDocuments } from "./ViewBudgetDocuments";

export const BudgetReportDocument = () => {

    const _budget = useDataBean(_BudgetID);
    const { instance, lista, setLista, bean, setBean } = _budget;
    const [data, setData] = useState<any>({

    });
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [type, setType] = useState<number>(26);
    const paginador = usePaginator();
    const modalDocumentos = useModal("Documentos", MODAL_LG);
    const modalGraph = useModal("Grafica", MODAL_XL);

    useEffect(() => {
        getBudgetYearByProps();
    }, [paginador.page])
    useEffect(() => {
        paginador.setPage(1);
    }, [data])

    const getBudgetYearByProps = () => {
        console.log(data);

        if (year > 0 && data.IDBudgetType >= 0) {
            instance.getBudgetInfoConsolidateByYear(year, 1, 15000, _single.cleanMap(data)).then(
                (resp: any) => {
                    if (resp.List) {                        
                        paginador.setPages(resp.NumberOfPages);
                        setLista(resp.List);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año y tipo de presupuesto obligatorio");
        }
    }

    const head25 = [
        { title: 'ID', property: 'IDDocument', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'No.', property: 'Consecutive', visible: true },
        { title: 'Total CDP', property: 'Value', visible: true,mask:MASK_MONEY },
        { title: 'Código Bpin', property: 'BPINCode', visible: true,mask:MASK_NUMBER },
        { title: 'Producto', property: 'BudgetProductName', visible: true },
        { title: 'Articulo', property: 'BudgetArticleName', visible: true },
        { title: 'Objecto', property: 'Description', visible: false },
        { title: 'RCDP', property: 'RCDPConsecutive', visible: true },
        { title: 'Total RCDP', property: 'RCDPTotal', visible: true,mask:MASK_MONEY },
        { title: 'RP', property: 'RPConsecutive', visible: true },
        { title: 'Total RP', property: 'RPTotal', visible: true,mask:MASK_MONEY },
        { title: 'RRP', property: 'RRPConsecutive', visible: true },
        { title: 'Total RRP', property: 'RRPTotal', visible: true,mask:MASK_MONEY },
        { title: 'OB', property: 'OBConsecutive', visible: true },
        { title: 'Total OB', property: 'OBTotal', visible: true,mask:MASK_MONEY },
        { title: 'CE', property: 'CEConsecutive', visible: true },
        { title: 'Total CE', property: 'CETotal', visible: true,mask:MASK_MONEY },


    ]
    const head26 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'Austeridad', property: 'IsAusterity', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },

        { title: 'IAD', property: 'IADValue', visible: true, mask: MASK_MONEY },
        { title: 'ACM', property: 'ACMValue', visible: true, mask: MASK_MONEY },
        { title: 'AP', property: 'APValue', visible: true, mask: MASK_MONEY },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documentos', icono: 'ri-git-merge-line', visible: true, evento: () => { modalDocumentos.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Reporte Presupuesto por Documento">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                {/* <div className="col-md-3">
                    <SelectBudgetTypes label="Tipo Presupuesto" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                </div> */}
                <div className="col-md-3">
                    <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                </div>
                {/* <div className="col-md-3">
                    <SelectBudgetResource idSelector={data.IDBudgetResource} onChange={(e) => { setData({ ...data, "IDBudgetResource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetSource idSelector={data.IDBudgetSource} onChange={(e) => { setData({ ...data, "IDBudgetSource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-4">
                    <SelectBudgetID jsonCode={data.BudgetIDStr} onChange={(e) => { setData({ ...data, "BudgetIDStr": e.JsonCode }) }} />
                </div> */}
                <div className="col-md-3 ">
                    <BasicButton useMargin icon="" eventClick={getBudgetYearByProps}>Buscar</BasicButton>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <BasicTable  head={type == 25 ? head26 : head25} body={lista} rowSet={setBean} listButtons={listaBotones()}
                    // pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalDocumentos.modal} updateModal={modalDocumentos.setModal}>
                        <ViewBudgetDocuments year={year} row={bean}/>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={type == 25 ? head26 : head25} useIndexAsXLabel={true}
                            xOptions={['NameBudgetType', 'BudgetIDStr', 'NameBudgetResource', 'NameBudgetSource', 'IsAusterity']}
                            yOptions={['PIValue', 'CCValue', 'CDPValue', 'RCDPValue', 'RPValue', 'OBValue', 'CEValue']} />

                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}